import request from '../request'

// MF-583 — server health (Maestro role only). Each call answers { data }.
export const getServerSummary = ({ range = '1h', includeHealth = false, server = null } = {}) =>
  request
    .get('/server-metrics/summary', { params: { range, includeHealth, ...(server ? { server } : {}) } })
    .then((res) => res?.data ?? null)

export const getServerWorkers = () => request.get('/server-metrics/servers').then((res) => res?.data ?? null)

export const getServerErrors = (limit = 50, server = null) =>
  request
    .get('/server-metrics/errors', { params: { limit, ...(server ? { server } : {}) } })
    .then((res) => res?.data ?? [])
